<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Comment-Root',
};
</script>
